import React from 'react';
import { styles } from './MenuSubheading.css';

export type MenuSubheadingProps = {
  label?: string;
};

export const MenuSubheading = ({ label }: MenuSubheadingProps) => {
  return <div className={styles.heading}> {label}</div>;
};
